import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@15.4.10_@opentelemetry+api@1.9.0_react-dom@19.1.2_react@19.1.2__react@19.1.2__react@19.1.2/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@15.4.10_@opentelemetry+api@1.9.0_react-dom@19.1.2_react@19.1.2__react@19.1.2__react@19.1.2/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.10_@opentelemetry+api@1.9.0_react-dom@19.1.2_react@19.1.2__react@19.1.2/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.10_@opentelemetry+api@1.9.0_react-dom@19.1.2_react@19.1.2__react@19.1.2/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.4.10_@opentelemetry+api@1.9.0_react-dom@19.1.2_react@19.1.2__react@19.1.2/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/icon.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/anyvideo/HeaderOptimized.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/anyvideo/HeroOptimized.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/blocks/feature4/OptimizedFeature4.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/HeaderSpacer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/LocaleLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/HydrationFix.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage"] */ "/app/src/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/FixedAnnouncementBanner.tsx");
